<template>
  <div v-loading="loading">
    <card class="w-100">
      <el-row :gutter="10">
        <el-form class="form-horizontal" ref="excel" label-width="120px">
          <el-col :span="20">
            <div class="form-group">
              <el-form-item label="등록할 엑셀 파일" prop="upload">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action="/api/media/excels"
                  :headers="header"
                  :limit="1"
                  :on-success="handleSuccess"
                  :auto-upload="false">
                  <el-button slot="trigger" size="small" type="primary">엑셀파일 선택</el-button>
                </el-upload>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="4">
              <el-button type="primary" icon="el-icon-check" @click="submitUpload">저장</el-button>
          </el-col>
        </el-form>
      </el-row>
    </card>
    <card class="w-100">
      <el-col :span="24">
        <aw-table border
                  id="advertisementTable"
                  style="width: 100%; margin-bottom: 10px; font-size: 10px"
                  :fixed-body-header="true"
                  drag-scroll-dir="x"
                  :border="true"
                  :data="advertisements"
                  :header-cell-style="tableRowStyle"
                  :row-class-name="tableRowClassName">
          <el-table-column
            fixed
            type="index"
            width="70">
          </el-table-column>
          <el-table-column
            fixed
            label="확인">
            <template slot-scope="props">
              {{ props.row.valid ? "정상" : props.row.errorFields}}
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="사진">
            <template slot-scope="props">
              <img v-bind:src="'/api/common/media/temp-image?path=' + props.row.filePath" style="width: 300px" />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            prop="companyName"
            label="업체명">
          </el-table-column>
          <el-table-column
            fixed
            prop="goodsName"
            label="상품명">
          </el-table-column>
          <el-table-column
            fixed
            prop="licenseNumber"
            label="사업자번호">
          </el-table-column>
          <el-table-column
            fixed
            prop="storeName"
            label="점포">
          </el-table-column>
          <el-table-column
            fixed
            label="매체구분">
            <template slot-scope="props">
              {{ getMediaType(props.row.mediaType) }}
            </template>
          </el-table-column>
          <el-table-column
            fixed
            prop="mediaName"
            label="매체명">
          </el-table-column>
          <el-table-column
            label="넓이(mm)">
            <template slot-scope="props">
              {{ props.row.width | numeral('0,0')}}
            </template>
          </el-table-column>
          <el-table-column
            label="높이(mm)">
            <template slot-scope="props">
              {{ props.row.height | numeral('0,0')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="profitText"
            label="현황구분">
          </el-table-column>
          <el-table-column
            prop="inOut"
            label="IN/OUT">
          </el-table-column>
          <el-table-column
            prop="isLight"
            label="조명여부/송출시간"
            width="150">
            <template slot-scope="props">
              {{ props.row.mediaType === "DM" ? props.row.duration : ""}}
              {{ props.row.mediaType === "WC" ? getIsLight(props.row.isLight) : ""}}
            </template>
          </el-table-column>
          <el-table-column
            label="연광고료">
            <template slot-scope="props">
              {{ props.row.prepaymentPrice | numeral('0,0')}}원
            </template>
          </el-table-column>
          <el-table-column
            label="월광고료">
            <template slot-scope="props">
              {{ props.row.installmentPrice | numeral('0,0')}}원
            </template>
          </el-table-column>
          <el-table-column
            prop="billingText"
            label="정산">
          </el-table-column>
          <el-table-column
            prop="month"
            width="90"
            label="개월수">
            <template slot-scope="props">
              {{ props.row.billingType === "D" ? props.row.month + " 개월" : "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="floorText"
            label="층">
          </el-table-column>
          <el-table-column
            prop="positionNumber"
            label="위치">
            <template slot-scope="props">
              {{ props.row.positionNumber + (props.row.positionCode !== undefined ? props.row.positionCode : "")}}
            </template>
          </el-table-column>

          <el-table-column
            prop="team"
            label="팀">
          </el-table-column>
          <el-table-column
            prop="category"
            label="대분류">
          </el-table-column>

          <el-table-column
            label="교체일"
            prop="replacementDate"
            width="120">
          </el-table-column>
          <el-table-column
            prop="etc"
            label="부킹여부">
          </el-table-column>
          <el-table-column
            prop="draftName"
            label="교체시안">
          </el-table-column>
          <el-table-column
            prop="positionInfo"
            label="위치안내">
          </el-table-column>
        </aw-table>
      </el-col>
      <el-col :span="24">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="register">등록하기</el-button>
          <el-button type="primary" icon="el-icon-minus" v-on:click="reset">리셋</el-button>
          <el-button type="primary" icon="el-icon-back" v-on:click="cancel">취소</el-button>
        </div>
      </el-col>
    </card>
  </div>
</template>

<script>
    import Vue from 'vue'
    import {Table, TableColumn, Input, Button, Select, Option, Row, Col, Form, FormItem, Upload, Loading, Notification, MessageBox} from 'element-ui'
    import VueMoment from 'vue-moment'
    import vueNumeralFilterInstaller from 'vue-numeral-filter';
    import AwTable from '@/components/UIComponents/Table/AwTable.vue'

    Vue.use(vueNumeralFilterInstaller)
    Vue.use(VueMoment)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Input)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(FormItem)
    Vue.use(Form)
    Vue.use(Upload)
    Vue.use(Loading)

    export default {
        name: "MediaExcelRegistration",
        components: {
          AwTable
        },
        created: function () {
            this.$store.dispatch('common/setMenuTitle', "엑셀등록");
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderFont10CellStyle;
            },
            tableRowClassName({row, rowIndex}) {
                if (row.valid) {
                    return 'success-row';
                } else {
                    return 'warning-row';
                }
            },
            submitUpload() {
                if(this.$refs.upload.uploadFiles.length > 0) {
                    this.loading = true;
                    this.advertisements = [];
                    this.errorCount = 0;
                    this.$refs.upload.submit();
                } else {
                    alert("엑셀파일을 선택하세요.");
                }
            },
            handleSuccess(response, files, fileList) {
                this.advertisements = response.advertisements;
                this.uploadParam.fileName = response.fileName;
                this.uploadParam.filePath = response.filePath;
                this.uploadParam.size = response.size;
                this.loading = false;
                this.setTopScroll();
                this.errorCount = this.advertisements.filter(function(advertisement) {
                    return !advertisement.valid;
                }).length;
                if(this.errorCount> 0) {
                    MessageBox.confirm(this.errorCount + '개의 열에 오류가 있습니다.\n오류가 있는 열만 보시겠습니까?', '오류', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.advertisements = this.advertisements.filter(function(advertisement) {
                            return !advertisement.valid;
                        });
                    }).catch(() => {

                    });
                }
                this.$refs.upload.clearFiles();
            },
            register() {
                if(this.advertisements.length > 0) {
                    if(this.errorCount > 0) {
                        alert("엑셀파일을 수정 후 다시 업로드하시기 바랍니다.");
                    } else {
                        if (confirm("등록 하시겠습니까?")) {
                            this.uploadParam.advertisements = this.advertisements;
                            this.$store.dispatch("media/uploadComplete", this.uploadParam);
                        }
                    }
                } else {
                    alert("엑셀파일을 등록하세요.");
                }
            },
            reset() {
                this.advertisements = [];
                this.$refs.upload.clearFiles();
                this.errorCount = 0;
            },
            cancel() {
                Vue.router.push({name: 'MediaExcelList'});
            },
            formatDate(date) {
                let d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [year, month, day].join('-');
            },
            // 상단 스크롤 생성
            setTopScroll() {
                $(function(){
                    $(".scroll-div1").width($("#advertisementTable .el-table__body").width());
                    $(".wmd-view-topscroll").scroll(function(){
                        $(".el-table--scrollable-x .el-table__body-wrapper").scrollLeft($(".wmd-view-topscroll").scrollLeft());
                    });
                    $(".el-table--scrollable-x .el-table__body-wrapper").scroll(function(){
                        $(".wmd-view-topscroll").scrollLeft($(".el-table--scrollable-x .el-table__body-wrapper").scrollLeft());
                    });
                });
            },
            getMediaType(media_type) {
              return Vue.getMediaType(media_type);
            },
            getIsLight(isLight) {
              return Vue.getIsLight(isLight);
            },
        },
        data() {
            return {
                header: {
                    Authorization:$cookies.get('id_token')
                },
                advertisements: [],
                uploadParam: {
                    fileName: '',
                    filePath: '',
                    size: '',
                    advertisements: [],
                },
                loading: false,
                errorCount: 0,
            }
        }
    }
</script>

<style>
  .warning-row  {
    background: #ecc8fd !important;;
  }

  .success-row {
    background: #fff !important;;
  }

  .wmd-view-topscroll {
    overflow-x: scroll;
    overflow-y: hidden;
    width: 100%;
    border: none 0px RED;
  }

  .wmd-view-topscroll { height: 20px; }
  .scroll-div1 {
    width: 1880px;
    overflow-x: scroll;
    overflow-y: hidden;
    height:20px;
  }
</style>
